import GpParser from "../../gpParser";
import { CATEGORIES } from "../../configuration/constants";

import Icon from "./Icon";
import Led from "./Led";
import LedGroup from "./LedGroup";

export default (editor, opt = {}) => {
  GpParser.loadFromList(
    [
      Icon,
      Led,
      LedGroup,
    ],
    CATEGORIES.MATERIALS,
    editor,
    opt
  );
};
